import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { SessionService } from '@v1/modules/auth/infra/session.service';

export const authGuard: CanActivateFn = (_route, state) => {
  const oauthService = inject(OAuthService);

  if (oauthService.hasValidAccessToken()) {
    return true;
  }

  const session = inject(SessionService);
  if (!oauthService.getRefreshToken()) {
    // A first visit is not a revoked session: keep the original login flow and destination.
    oauthService.initCodeFlow(state.url);
    return false;
  }
  return session.refresh().then(
    () => oauthService.hasValidAccessToken(),
    (error: unknown) => {
      const response = error as { status?: number; error?: { error?: string; error_description?: string } };
      if ((response.status === 400 || response.status === 401) &&
          response.error?.error === 'invalid_grant' &&
          response.error.error_description?.includes('session_revoked')) session.closeLocally();
      return false;
    },
  );
};
